import React from 'react';
import { formatINR } from '../checkout/formatINR';
import {
  productDiscountPercent,
  productEffectivePrice,
  productOnSale,
  productRegularPrice,
} from '../productPricing';

/**
 * Storefront price: regular, or was/now with optional % badge.
 */
export default function ProductPrice({ product, className = '', showBadge = true, as = 'span' }) {
  const Tag = as;
  const regular = productRegularPrice(product);
  const effective = productEffectivePrice(product);
  const onSale = productOnSale(product);

  if (effective <= 0) {
    return <Tag className={className}>Price on request</Tag>;
  }

  if (!onSale) {
    return <Tag className={`product-price ${className}`.trim()}>{formatINR(effective)}</Tag>;
  }

  const pct = productDiscountPercent(product);

  return (
    <Tag className={`product-price product-price--on-sale ${className}`.trim()}>
      <span className="product-price__was">{formatINR(regular)}</span>
      <span className="product-price__now">{formatINR(effective)}</span>
      {showBadge && pct > 0 ? <span className="product-price__badge">{pct}% off</span> : null}
    </Tag>
  );
}
